<template>
  <v-container class="mt-5">
    <DealsFilters :user="user" />
    <div class="container">
      <div>
        Total coverage: <b>${{deals.totalCoverage}}</b>
      </div>
      <div>
        Total premium: <b>{{deals.totalPremium? "$" + deals.totalPremium.toFixed(2): "No info"}}</b>
      </div>
    </div>
    <DealsTable :user="user" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DealsFilters from "@/components/filters/DealsFilters";
import DealsTable from "@/components/table/DealsTable";

export default {
  name: "Deals",
  components: { 
    DealsFilters,
    DealsTable,
  },
  methods: {
      ...mapActions({
      loadAgents: "agents/loadAgents",
      loadSources: "sources/loadSources",
      loadDeals: "deals/loadDeals",
    }),
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      deals: "deals/deals"
    }),
  },
};
</script>
